export var AccountSearchType;
(function (AccountSearchType) {
    AccountSearchType["PLAYER"] = "player";
    AccountSearchType["AGENT"] = "agent";
})(AccountSearchType || (AccountSearchType = {}));
//# sourceMappingURL=AccountSearchType.js.map